import { render, staticRenderFns } from "./GiantCredibleSets.vue?vue&type=template&id=124a8f84&"
import script from "./GiantCredibleSets.vue?vue&type=script&lang=js&"
export * from "./GiantCredibleSets.vue?vue&type=script&lang=js&"
import style0 from "./GiantCredibleSets.vue?vue&type=style&index=0&id=124a8f84&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('124a8f84')) {
      api.createRecord('124a8f84', component.options)
    } else {
      api.reload('124a8f84', component.options)
    }
    module.hot.accept("./GiantCredibleSets.vue?vue&type=template&id=124a8f84&", function () {
      api.rerender('124a8f84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/GiantCredibleSets.vue"
export default component.exports